/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Reason for the refund - maps to Ping Payments RefundReason
 * @export
 */
export const WebApiModelsEnumerationTypesPaymentRefundReason = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type WebApiModelsEnumerationTypesPaymentRefundReason = typeof WebApiModelsEnumerationTypesPaymentRefundReason[keyof typeof WebApiModelsEnumerationTypesPaymentRefundReason];


export function WebApiModelsEnumerationTypesPaymentRefundReasonFromJSON(json: any): WebApiModelsEnumerationTypesPaymentRefundReason {
    return WebApiModelsEnumerationTypesPaymentRefundReasonFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesPaymentRefundReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesPaymentRefundReason {
    return json as WebApiModelsEnumerationTypesPaymentRefundReason;
}

export function WebApiModelsEnumerationTypesPaymentRefundReasonToJSON(value?: WebApiModelsEnumerationTypesPaymentRefundReason | null): any {
    return value as any;
}

